import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getCouponsForBrokeNotification } from '../../services'
import { BatchesQueryKeys } from '@/modules/batches/keys'
import { GetCouponsResponse } from '@/modules/batches/type'

export default function useQueryGetCouponsForBrokeNotification(
	props?: UseBaseQueryOptions<GetCouponsResponse>,
) {
	return useQuery({
		queryKey: [BatchesQueryKeys.GetCouponsForBrokeNotification],
		queryFn: () => getCouponsForBrokeNotification(),
		...props,
	})
}
